<label
  [ngStyle]="checkboxStyles()"
  class="inline-flex cursor-pointer select-none items-center gap-3"
>
  <input
    type="checkbox"
    class="hidden"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="checked.set($any($event.target).checked)"
  />

  <div
    [ngClass]="checkboxClasses()"
    class="inline-flex h-4 w-4 items-center justify-center rounded-sm border transition-all duration-200 border(--checkbox-icon)"
  >
    @if (checked()) {
      <bevvi-icon [icon]="checkboxIcon" [size]="iconSize" />
    }
  </div>

  @if (label()) {
    <span class="text-body font-medium text-(--checkbox-label)">
      {{ label() }}
    </span>
  }
</label>
